import MuiDivider, {
  DividerProps as MuiDividerProps
} from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';

export type DividerProps = MuiDividerProps;

const Divider = withStyles<'root', {}, DividerProps>(
  theme => ({
    root: {
      backgroundColor: theme.palette.text.primary,
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4)
    },
    absolute: {
      marginTop: 0,
      marginBottom: 0
    },
    vertical: {
      marginTop: 0,
      marginBottom: 0
    }
  }),
  { name: 'FdDivider' }
)(MuiDivider);

export default Divider;
